import React, { useState } from "react";
// eslint-disable-next-line no-undef
const passcode = process.env.REACT_APP_PASSCODE;

function AreaPrivata() {
    const [showInput, setShowInput] = useState(true);
    const [arrayLinks, setArrayLinks] = useState([]);
    const [userInput, setUserInput] = useState("");
    const [errore, setErrore] = useState("");

    function submitPass() {
        //sanitize???
        console.log(userInput === passcode);
        if (userInput === passcode) {
            setShowInput(false);
            callForLinks();
            setErrore("");
        } else {
            setErrore("Password errata!");
        } //METTI UN TOAST
    }

    function callForLinks() {
        const queryURL = "https://raw.githubusercontent.com/ginniped/publicJson/main/json";
        const reqOpt = {
            mode: "cors",
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        };

        fetch(queryURL, reqOpt)
            .then(function (response) {
                return response.json();
            })
            .then((res) => {
                res.softwaresLinks ? setArrayLinks(res.softwaresLinks) : setArrayLinks([]);
            })
            .catch(function (error) {
                console.log("Error during fetch: " + error.message);
            });
    }

    function handleKeyPress(e) {
        if (e.key === "Enter") {
            submitPass();
        }
    }

    return (
        <div className='content'>
            <div className='contentAreaPrivata'>
                <br />
                {showInput && (
                    <>
                        <label htmlFor='password' style={{ marginBottom: "1%" }}>
                            {" "}
                            PASSWORD:{" "}
                        </label>
                        <input
                            type='password'
                            name='password'
                            value={userInput}
                            onChange={(e) => setUserInput(e.target.value)}
                            onKeyDown={(e) => handleKeyPress(e)}
                        />
                        <div className='submitButton' onClick={() => submitPass()}>
                            GO
                        </div>
                        <div style={{ marginTop: "2%" }}>{errore}</div>
                    </>
                )}
                {arrayLinks?.map((link, i) => {
                    return (
                        <div className='linkContainer' key={i}>
                            <a
                                href={`https://www.emme-effe.it/Software/${link.nomeLink}`}
                                target='_blank'
                                rel='noreferrer'>
                                {link.nome.toUpperCase()}
                            </a>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default AreaPrivata;
